import { faCube } from "@fortawesome/pro-regular-svg-icons";

import { Pill } from "src/design-system/Pill";
import { Tooltip } from "src/design-system/Tooltip";
import { entityIcons } from "src/entities/entityView/utils";
import { EntitySchemaResource } from "src/entities/queries";

export const EntityPill: React.FC<{
  resource: EntitySchemaResource;
}> = ({ resource }) => {
  return (
    <Tooltip placement="bottom" title={resource._display_name_singular} asChild>
      <Pill size="sm" variant="gray" fullWidth>
        <Pill.Icon icon={entityIcons[resource._display_symbol] ?? faCube} />
        <Pill.Text>{resource._display_name_singular}</Pill.Text>
      </Pill>
    </Tooltip>
  );
};
